// @flow
import type {Element, Node} from 'react'
import React from 'react'
import {isEmpty} from 'ramda'

type Props = {
  children: Node,
}

function InnerContent({children}: Props): Element<"div"> {
  return (
    <div className="proposal-summary-inner-content">
      {isEmpty(children)
        ? I18n.t('proposal.sentences.no_changes_yet2')
        : children
    }
    </div>
  )
}

export default InnerContent
